import { GridColDef } from '@mui/x-data-grid-pro';
import { DisplayMoney, DisplayNumber } from '@price-for-profit/data-grid';
import { DisplayDate } from 'shared/components';
import { ImportanceDropdown } from './importance-dropdown';
import { SegmentDropdown } from './segment-dropdown';

export const columnsCustomerParameters = ({ admin }: { admin: boolean }) => {
  const columns: GridColDef[] = [
    {
      headerName: 'Master Customer Name',
      field: 'masterCustomerName',
      width: 180,
    },
    {
      headerName: 'Current Segment',
      field: 'currentSegment',
      width: 130,
    },
    {
      headerName: 'Revised Segment',
      field: 'revisedSegment',
      width: 130,
      editable: admin,
      cellClassName: 'drive-app-wps--cell--editable',
      renderEditCell: params => <SegmentDropdown {...params} />,
    },
    {
      headerName: 'Segment Last Modified',
      field: 'segmentLastModified',
      width: 165,
      renderCell: DisplayDate,
    },
    {
      headerName: 'Commodity',
      field: 'commodity',
      width: 100,
    },
    {
      headerName: 'Current Importance',
      field: 'currentImportance',
      width: 140,
    },
    {
      headerName: 'Revised Importance',
      field: 'revisedImportance',
      width: 150,
      editable: admin,
      cellClassName: 'drive-app-wps--cell--editable',
      renderEditCell: params => <ImportanceDropdown {...params} />,
    },
    {
      headerName: 'Current Price Level',
      field: 'currentPriceLevel',
      width: 140,
    },
    {
      headerName: 'Revised Price Level',
      field: 'revisedPriceLevel',
      width: 140,
    },
    {
      headerName: 'Importance Last Modified',
      field: 'importanceLastModified',
      width: 180,
      renderCell: DisplayDate,
    },
    {
      headerName: 'Revenue',
      field: 'revenue',
      width: 130,
      renderCell: DisplayMoney({ decimalScale: 0 }),
    },
    {
      headerName: 'Margin',
      field: 'margin',
      width: 130,
      renderCell: DisplayMoney({ decimalScale: 0 }),
    },
    {
      headerName: 'Cases Sold',
      field: 'casesSold',
      width: 130,
      renderCell: DisplayNumber({ decimalScale: 0 }),
    },
    {
      headerName: 'Current Avg Margin per Case',
      field: 'avgMarginPerCase',
      width: 200,
      renderCell: DisplayNumber({ decimalScale: 2, fixedDecimalScale: true }),
    },
  ];

  return columns;
};
